import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { scandataEmptyTranslations } from './scandata-empty.translations';

export enum ScandataEmptyReason {
  NoUploads,
  NoFilterResults,
  NoGeolocated,
  NoSelected,
  NoRecycled,
}

@Component({
  selector: 'sd-scandata-empty',
  standalone: true,
  templateUrl: './scandata-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScandataEmptyComponent {
  readonly translations = scandataEmptyTranslations();

  readonly reason = input.required<string, ScandataEmptyReason>({
    transform: (reason) => {
      switch (reason) {
        case ScandataEmptyReason.NoUploads:
          return this.translations.noUploads.text;

        case ScandataEmptyReason.NoFilterResults:
          return this.translations.noFilterResults.text;

        case ScandataEmptyReason.NoGeolocated:
          return this.translations.noGeolocated.text;

        case ScandataEmptyReason.NoSelected:
          return this.translations.noSelected.text;

        case ScandataEmptyReason.NoRecycled:
          return this.translations.noRecycled.text;
      }
    },
  });
}
